import React, { useState } from 'react'
import AdminImg from "../../images/default avatar.jpg";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleSidebar } from '../../redux/features/sidebarSlice';

const DashHeader = (props) => {
    
    const [ dropDwn, setDropDwn ] = useState(false)
    const dispatch = useDispatch()
    const sidebar = useSelector((state) => state.sidebar.value)
    const { fullName, profilePicture } = useSelector((state) => state.auth.user)

    
    const sidebarHandler = () => {
        dispatch(toggleSidebar(!sidebar))
    }

    const dropDwnHandler = () => {
        setDropDwn(!dropDwn)
    }

    return (
        <header>
            <div className="row p-relative">
                <div className="col-10 col-sm-8">
                    <h4 className='fw-bold'>
                        <span className="btn ps-0 pe-1 d-inline d-md-none" onClick={sidebarHandler}>
                            <i className="ri-menu-4-line ri-lg ri-bold"></i>
                        </span>
                        {props.title}
                    </h4>
                </div>
                <div className="col-2 col-sm-4 text-end c-pointer d-flex justify-content-end align-items-center" onClick={dropDwnHandler}>
                    <img src={profilePicture?.url || AdminImg} alt="admin dp" height={40} width={40} style={{ borderRadius: "50%" }} />
                    <span className="px-2 fw-bold d-md-inline d-none">{fullName?.split(" ")[0]}</span>
                    <i className="ri-arrow-down-s-line d-sm-inline d-none font-weight-bold"></i>
                </div>
                { dropDwn ? 
                    <>
                        <div className="bg-white pull-up rounded text-start admin-drpdwn p-2 py-3">
                            <Link to="/dashboard/admin/edit-profile" className="text-dark text-decor-none p-2">Edit Profile</Link><br />
                            <Link to={"/dashboard/admin/change-password"} className="text-dark text-decor-none p-2">Change Password</Link><br />
                        </div>
                        <div className="modal d-block transparent" onClick={dropDwnHandler}>
                        </div>
                    </>
                : '' }
            </div>
            
        </header>
    )
}

export default DashHeader
